module.exports = __webpack_public_path__ + "static/bandera-europa-df9ef5dab6e5785787ca9e707eda8a01.svg";